<script setup lang="ts">
import { usePWAStore } from '../stores/pwa'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

const pwa = usePWAStore()
const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')

const visible = computed(() => pwa.showInstallCard && isMobile.value)

function install() {
  pwa.install()
}
function dismiss() {
  pwa.dismissInstall()
}
</script>

<template>
  <div v-if="visible" class="iap-wrap">
    <div class="iap-card">
      <div class="iap-icon">📱</div>
      <div class="iap-text">
        <div class="iap-title">安装云璃 APP</div>
        <div class="iap-sub">
          <template v-if="pwa.isIOS">
            点击浏览器底部「分享」→「添加到主屏幕」，即可像原生 APP 一样使用。
          </template>
          <template v-else>
            添加到主屏幕，获得更流畅的全屏沉浸式体验。
          </template>
        </div>
      </div>
      <button v-if="!pwa.isIOS" class="iap-btn" @click="install">安装</button>
      <button class="iap-close" @click="dismiss" aria-label="关闭">✕</button>
    </div>
  </div>
</template>

<style scoped>
.iap-wrap {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: calc(12px + env(safe-area-inset-bottom));
  z-index: 200;
  display: flex;
  justify-content: center;
  pointer-events: none;
}
.iap-card {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 480px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(251, 247, 236, 0.96);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(8px);
  color: #2b2b2b;
}
.iap-icon { font-size: 26px; line-height: 1; }
.iap-text { flex: 1; min-width: 0; }
.iap-title { font-weight: 700; font-size: 14px; }
.iap-sub { font-size: 12px; opacity: 0.75; margin-top: 2px; line-height: 1.35; }
.iap-btn {
  flex: none;
  border: none;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  cursor: pointer;
}
.iap-close {
  flex: none;
  border: none;
  background: transparent;
  font-size: 16px;
  opacity: 0.5;
  cursor: pointer;
  padding: 4px;
}
</style>
